import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { BookOpen } from "lucide-react";

/**
 * The "know" part of the page. Plain teaching copy only.
 */
export default function CurrentEditionKnowCard() {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-lg">
          <BookOpen className="h-5 w-5 text-primary" />
          What to know
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-3 text-sm leading-relaxed">
        <p>
          Your Constitution has a current edition. It is called the Amended and Restated
          Constitution. It is the newest and clearest version of the same governing paper you
          already hold.
        </p>
        <p>
          When you adopt it, it takes the place of your existing governing documents in full. You
          will hold one clear set instead of an older set plus changes.
        </p>
        <p>
          Your Association keeps going just as it is. Same Association, same EIN. There is no new
          formation. Nothing changes at the bank.
        </p>
        <p>The current edition has 16 articles and three appendices.</p>
      </CardContent>
    </Card>
  );
}
